import React from 'react';
import { useHistory } from 'react-router-dom';
import './MergeChunkErrorDialog.css';
import { Button } from 'unified-ui-components-library';

const MergeChunkErrorDialog = () => {

    const router = useHistory()

    const handleClose = () => {
        router.push('/video-consent')
    }

    return (
        <div className="mergeChunkDialogBx">
            <div className="mergeChunkDialogBxContent">
                <div className="mergeChunkDialogBxContentWrapper">
                    <p className="mergeChunkDialogText">Something was wrong.</p>
                    <p className="mergeChunkDialogText">Kindly re-record the consent</p>
                    <div className='button_div_unified'>
                        <Button
                            // className="mergeChunkDialogBtn submit_button--generate_otp"
                            buttonType="primary"
                            size='small'
                            onClick={handleClose}
                        >
                            Close
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MergeChunkErrorDialog
